import { useContext } from 'react';

import { ModalContext } from 'src/shared/model/modal';

import type { UseBooleanReturn } from './use-boolean';

type UseDrawerOptions = {
  state: UseBooleanReturn;
  onClose?: () => void;
};

type UseDrawerReturn = {
  toggleDrawer: (newOpen: boolean) => () => void;
};

export function useDrawer({ state, onClose }: UseDrawerOptions): UseDrawerReturn {
  const { setIsOpen } = useContext(ModalContext);

  const toggleDrawer = (newOpen: boolean) => () => {
    setIsOpen(newOpen);
    state.setValue(newOpen);
    if (!newOpen) {
      onClose?.();
    }
  };

  return { toggleDrawer };
}
